export default __webpack_public_path__ + "static/media/switch-off.f74cfc00.svg";